import React, { useState } from "react";

interface BeneficiaryModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (beneficiaryName: string) => void;
  userFullName?: string;
}

const BeneficiaryModal: React.FC<BeneficiaryModalProps> = ({
  show,
  onClose,
  onSubmit,
  userFullName = "",
}) => {
  const [beneficiaryType, setBeneficiaryType] = useState<"self" | "other">(
    "self"
  );
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [error, setError] = useState<string | null>(null);

  if (!show) return null;

  const handleSubmit = () => {
    const name = beneficiaryType === "self" ? userFullName : beneficiaryName;
    if (!name.trim()) {
      setError("Please enter the beneficiary's name.");
      return;
    }
    setError(null);
    onSubmit(name.trim());
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full mx-4">
        <h3 className="text-2xl font-bold text-[#1e2b5e] mb-6 font-georgia">
          Who is this visa application for?
        </h3>

        <div className="space-y-4 mb-6">
          <label className="flex items-center p-4 border-2 rounded-xl cursor-pointer hover:border-[#F4A261] transition-colors">
            <input
              type="radio"
              name="beneficiary-type"
              value="self"
              checked={beneficiaryType === "self"}
              onChange={() => setBeneficiaryType("self")}
              className="mr-4 h-5 w-5 text-[#F4A261]"
              style={{ accentColor: "#F4A261" }}
            />
            <span className="text-lg text-[#1B365D]">Myself</span>
          </label>

          <label className="flex items-center p-4 border-2 rounded-xl cursor-pointer hover:border-[#F4A261] transition-colors">
            <input
              type="radio"
              name="beneficiary-type"
              value="other"
              checked={beneficiaryType === "other"}
              onChange={() => setBeneficiaryType("other")}
              className="mr-4 h-5 w-5 text-[#F4A261]"
              style={{ accentColor: "#F4A261" }}
            />
            <span className="text-lg text-[#1B365D]">
              Someone else (Beneficiary)
            </span>
          </label>
        </div>

        {beneficiaryType === "other" && (
          <div className="mb-6">
            <label className="block text-sm font-semibold mb-2 text-[#1B365D]">
              Beneficiary's Full Name
            </label>
            <input
              type="text"
              value={beneficiaryName}
              onChange={(e) => {
                setBeneficiaryName(e.target.value);
                if (error) setError(null);
              }}
              placeholder="Enter full name"
              className="w-full p-3 border-2 rounded-xl focus:border-[#F4A261] focus:outline-none"
              autoFocus
            />
          </div>
        )}

        {error && (
          <p className="text-sm text-red-600 mb-4" role="alert">
            {error}
          </p>
        )}

        <div className="flex gap-4">
          <button
            onClick={onClose}
            className="flex-1 py-3 border-2 border-[#1B365D] text-[#1B365D] rounded-full font-semibold hover:bg-[#1B365D] hover:text-white transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 py-3 bg-[#F4A261] text-[#1B365D] rounded-full font-semibold hover:bg-[#F29449] transition-colors"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default BeneficiaryModal;
